import { DELETE_PORTOFOLIO_ERROR, DELETE_PORTOFOLIO_START, DELETE_PORTOFOLIO_SUCCESS } from '../../types';

export default function delete_portofolio(state, action) {
  switch (action.type) {
    case DELETE_PORTOFOLIO_START:
      return { ...state };
    case DELETE_PORTOFOLIO_SUCCESS:
      return {
        ...state,
        data: action.results,
        error: null,
      };
    case DELETE_PORTOFOLIO_ERROR:
      return {
        ...state,
        data: null,
        error: action.error
      };
    default:
      return { ...state };
  }
}